import React from 'react'
import { useParams, Link } from 'react-router-dom'
import { Card, Button, Alert, Spinner, Row, Col, Badge } from 'react-bootstrap'
import { useAdminDataAccess } from 'api/hooks/use-admin-data-accesses'

const DataAccessDetail = () => {
  const { id } = useParams()
  const { data: dataAccess, isLoading, error } = useAdminDataAccess({ id })

  if (isLoading) {
    return (
      <div className="text-center p-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    )
  }

  if (error) {
    return <Alert variant="danger">Error loading data access: {error.message}</Alert>
  }

  if (!dataAccess) {
    return <Alert variant="warning">Data access not found.</Alert>
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>{dataAccess.category} - {dataAccess.name}</h2>
        <div>
          <Button as={Link} to={`/admin/data-accesses/${id}/edit`} variant="warning" className="me-2">Edit</Button>
          <Button as={Link} to="/admin/data-accesses" variant="light-primary">Back to List</Button>
        </div>
      </div>

      <Row>
        <Col md={6}>
          <Card className="mb-4">
            <Card.Header><h5>Basic Information</h5></Card.Header>
            <Card.Body>
              <dl className="row mb-0">
                <dt className="col-sm-5">Category:</dt>
                <dd className="col-sm-7"><code>{dataAccess.category}</code></dd>
                <dt className="col-sm-5">Name:</dt>
                <dd className="col-sm-7">{dataAccess.name || 'N/A'}</dd>
                <dt className="col-sm-5">Description:</dt>
                <dd className="col-sm-7">{dataAccess.description || 'N/A'}</dd>
                <dt className="col-sm-5">Table ID:</dt>
                <dd className="col-sm-7">{dataAccess.table_id || 'N/A'}</dd>
                <dt className="col-sm-5">Do Toggle:</dt>
                <dd className="col-sm-7">
                  {dataAccess.do_toggle ? <Badge bg="success">Yes</Badge> : <Badge bg="secondary">No</Badge>}
                </dd>
              </dl>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card className="mb-4">
            <Card.Header><h5>Access & Module Settings</h5></Card.Header>
            <Card.Body>
              <dl className="row mb-0">
                <dt className="col-sm-5">Access Type:</dt>
                <dd className="col-sm-7">{dataAccess.access_type || 'N/A'}</dd>
                <dt className="col-sm-5">Access:</dt>
                <dd className="col-sm-7">{dataAccess.access || 'N/A'}</dd>
                <dt className="col-sm-5">Permission Category:</dt>
                <dd className="col-sm-7">{dataAccess.permission_category || 'N/A'}</dd>
                <dt className="col-sm-5">Permission Key:</dt>
                <dd className="col-sm-7">{dataAccess.permission_key || 'N/A'}</dd>
                <dt className="col-sm-5">Top Module Code:</dt>
                <dd className="col-sm-7">{dataAccess.top_module_code || 'N/A'}</dd>
                <dt className="col-sm-5">Sub Module Code:</dt>
                <dd className="col-sm-7">{dataAccess.sub_module_code || 'N/A'}</dd>
                <dt className="col-sm-5">Top Module Name:</dt>
                <dd className="col-sm-7">{dataAccess.top_module_name || 'N/A'}</dd>
              </dl>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default DataAccessDetail
